export type LegacyStaffRole = '1' | '2'

export interface LegacyStaffMember {
  id: string
  office: string
  username: string
  name: string
  phone: string
  level: string
  memo: string
  role: LegacyStaffRole
  hidden: boolean
  joinDate: string
  permissions: string[]
}

export const legacyStaffOffices = Array.from({ length: 26 }, (_, index) => ({
  value: String(index + 1),
  label: `모의지점 ${String(index + 1).padStart(2, '0')}`,
}))

const staffLevels = ['지점 관리자', '직원', 'TM 담당자']

const branchStaff: LegacyStaffMember[] = Array.from({ length: 24 }, (_, index) => ({
  id: `branch-${index + 1}`,
  office: legacyStaffOffices[0].label,
  username: `mock.staff.${String(index + 1).padStart(2, '0')}`,
  name: `모의직원 ${String(index + 1).padStart(2, '0')}`,
  phone: `010-0000-${String(index + 1).padStart(4, '0')}`,
  level: staffLevels[index % staffLevels.length],
  memo: index % 3 === 0 ? 'Mock 상담 담당' : '',
  role: '1',
  hidden: index >= 19,
  joinDate: `2026-${String((index % 8) + 1).padStart(2, '0')}-01`,
  permissions: index % 2 === 0 ? ['page-1', 'page-3', 'func-2'] : ['page-2', 'func-1'],
}))

const outsideStaff: LegacyStaffMember[] = Array.from({ length: 8 }, (_, index) => ({
  id: `outside-${index + 1}`,
  office: '-',
  username: `mock.vendor.${String(index + 1).padStart(2, '0')}`,
  name: `모의외주 ${String(index + 1).padStart(2, '0')}`,
  phone: `010-9999-${String(index + 1).padStart(4, '0')}`,
  level: '-',
  memo: 'Mock 외주계정',
  role: '2',
  hidden: index >= 6,
  joinDate: '',
  permissions: [],
}))

export const legacyStaffMembers = [...branchStaff, ...outsideStaff]

export const legacyStaffLevels = [
  { value: '2', label: '브랜드 관리자' },
  { value: '7', label: '그룹 관리자' },
  { value: '3', label: '지점 관리자' },
  { value: '5', label: '직원' },
  { value: '6', label: 'TM 담당자' },
]

export const legacyStaffPagePermissions = Array.from({ length: 12 }, (_, index) => ({
  id: `page-${index + 1}`,
  label: `Mock 페이지 권한 ${String(index + 1).padStart(2, '0')}`,
}))

export const legacyStaffFunctionPermissions = Array.from({ length: 15 }, (_, index) => ({
  id: `func-${index + 1}`,
  label: `Mock 기능 권한 ${String(index + 1).padStart(2, '0')}`,
}))
